import { useState } from 'react';
import { useIntl } from 'react-intl';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import ContentManager from 'src/componentes/content-manager';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';
import useAuth from 'src/hooks/useAuth';
import ConsequenciasRiscoEdit from './edit';

const ConsequenciasRiscoList = (props) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [saved, setSaved] = useState(0);

  const afterRemove = () => {
    setSaved((prev) => prev + 1);
  };

  const handleDeleteClick = (item) => {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/ConsequenciaRisco/ValidarRestricoes"
        urlExclusao="/ConsequenciaRisco/Remove"
        item={item}
        afterRemove={afterRemove}
        urlEdit="/ConsequenciaRisco/edit"
        isEdit={true}
      />
    );
  };

  return (
    <List
      url="/ConsequenciaRisco"
      editComponent={ConsequenciasRiscoEdit}
      tag={12021}
      showSearch
      onDeleting={handleDeleteClick}
      saved={saved}
      resources={resources}
      {...props}
    >
      <ListColumn
        headerText={intl.formatMessage({ id: 'idIntegracao' })}
        valueField="idIntegracao"
        required
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'descricao' })}
        valueField="descricao"
        required
      />
    </List>
  );
};

export default ConsequenciasRiscoList;
